/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 */

import axios from "axios";
import { actions as CommonActions } from "../reducers/app";
import history from "../history/index";
import { toast_notifications } from "./notifications";
import { API_URL } from "../config";
import { options } from "../services";

export default function idleListener(dispatch) {
  let t;
  // let m;
  window.onload = resetTimer;
  window.onmousemove = resetTimer;
  window.onmousedown = resetTimer; // catches touchscreen presses as well
  window.ontouchstart = resetTimer; // catches touchscreen swipes as well
  window.onclick = resetTimer; // catches touchpad clicks as well
  window.onkeypress = resetTimer;
  window.addEventListener("scroll", resetTimer, true); // improved; see comments

  function showNotification() {
    toast_notifications.info(
      "You have been inactive for 5 minute(s). You will be logged off automatically."
    );
  }

  async function logout() {
    toast_notifications.info("You have been inactive for 5 minute(s). You have been logged out.");
    try {
      await axios(options(API_URL + `/auth/log-out`, {}, "get"));
      history.push("/");
      history.replace("/");
      history.go("/");
      showNotification();
      dispatch(CommonActions.goOffline());
      sessionStorage.clear();
    } catch (error) {
      console.error("Error logging out:", error);
      sessionStorage.clear();
      history.push("/");
      history.replace("/");
      history.go("/");
      dispatch(CommonActions.goOffline());
    }
  }

  function resetTimer() {
    clearTimeout(t);
    // m = setTimeout(showNotification, 290000);  // time is in milliseconds
    t = setTimeout(logout, 300000); // time is in milliseconds
  }
}
